import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { App, ConfiguredApp } from '../../../interfaces/app';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { AppsService } from '../../../services/apps/apps.service';
import { map, share } from 'rxjs/operators';
import { IRestaurantInfo } from '../../../interfaces/restaurant';
import { AdminService } from '../../../services/admin/admin.service';

@Component({
  selector: 'app-configured-page',
  templateUrl: './all-configured-app-page.component.html',
  styleUrls: ['./all-configured-app-page.component.scss']
})
export class AllConfiguredAppPageComponent implements OnInit {
  public data$!: Observable<{ app: App; configuredApps: ConfiguredApp[] }>;
  public isEditedSubject = new BehaviorSubject(false);
  private chainIdSubject = new BehaviorSubject<number>(0);
  private appIdSubject = new BehaviorSubject<string>('');
  public allRestaurants$!: Observable<IRestaurantInfo[]>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appsService: AppsService,
    private adminService: AdminService,
  ) {}

  public get chainId(): number {
    return this.chainIdSubject.value;
  }

  public get appId(): string {
    return this.appIdSubject.value;
  }

  ngOnInit(): void {
    const chainId = Number(this.route.parent?.snapshot.paramMap.get('id'));
    const appId = this.route.snapshot.paramMap.get('appId') ?? '';

    this.allRestaurants$ = this.adminService.getRestaurantsByChainId(chainId).pipe(share());
    this.chainIdSubject.next(chainId);
    this.appIdSubject.next(appId);

    const app$ = this.appsService.getAppById(chainId, appId);
    const allConfigured$ = this.appsService.getAllConfiguredApps(chainId);

    this.data$ = combineLatest([app$, allConfigured$]).pipe(
      map(([app, configuredApps]) => ({ app, configuredApps }))
    );
  }

  get isEdited(): boolean {
    return this.isEditedSubject.value;
  }

  public toggleEdit(): void {
    this.isEditedSubject.next(!this.isEdited);
  }

  public backToAppsList(): void {
    this.router.navigate(['/chains', this.chainId.toString(), 'apps']);
  }

}
